(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var btn = e.target.closest('.prod-card__info-btn');

    if (btn) {
      var panel = btn.closest('.prod-card__media').querySelector('.prod-card__info-panel');
      var open  = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.setAttribute('aria-hidden', String(open));
    } else if (!e.target.closest('.prod-card__info-panel')) {
      document.querySelectorAll('.prod-card__info-panel[aria-hidden="false"]').forEach(function (panel) {
        panel.setAttribute('aria-hidden', 'true');
        panel.closest('.prod-card__media')
          .querySelector('.prod-card__info-btn')
          .setAttribute('aria-expanded', 'false');
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
